<template>
  <div
    :class="[
      'field--checkbox',
      ...classObject,
    ]"
  >
    <InputfieldDescription :text="description" />
    <div class="field__content">
      <label
        :for="fieldId"
        class="checkLabel"
        :class="labelClass"
      >
        <input
          type="checkbox"
          class="field__input"
          v-bind="[$attrs, $listeners]"
          :id="fieldId"
          :name="name"
          :value="value"
          :checked="isChecked ? 'checked' : ''"
          :disabled="disabled"
          @change="toggleCheck(name)"
        >
        <span
          v-if="showSwitch"
          :class="switchClass"
        >
          <span class="switch__circle" />
        </span>
        {{ label }}
      </label>
    </div>
    <InputfieldErrors :items="parsedErrors" />
    <InputfieldNotes :text="notes">
      <slot name="notes" />
    </InputfieldNotes>
  </div>
</template>

<script>

import InputfieldMixin from '@/components/forms/InputfieldMixin'
import InputfieldDescription from '@/components/forms/InputfieldDescription'
import InputfieldNotes from '@/components/forms/InputfieldNotes'

export default {
  name: 'InputfieldCheckbox',
  inheritAttrs: false,
  mixins: [
    InputfieldMixin,
  ],
  components: {
    InputfieldDescription,
    InputfieldNotes,
  },
  props: {
    model: {
      type: [String, Number, Boolean, Array],
    },
    value: {
      type: [String, Number, Boolean],
      default: true,
    },
    showSwitch: {
      type: Boolean,
      required: false,
      default () {
        return false
      },
    },
  },
  model: {
    prop: 'model',
    event: 'change',
  },
  computed: {
    isChecked () {
      if (this.isModelArray) return this.model.includes(this.value)
      if (this.isModelBoolean && this.value === true) return this.model

      return this.model === this.value
    },
    isModelArray () {
      return Array.isArray(this.model)
    },
    isModelBoolean () {
      return typeof this.model === 'boolean'
    },
    switchClass () {
      return [
        'switch',
        this.isChecked ? 'switch--on' : 'switch--off',
      ]
    },
  },
  methods: {
    removeItemFromModel (newModel) {
      const index = newModel.indexOf(this.value)

      if (index !== -1) {
        newModel.splice(index, 1)
      }
    },
    handleArrayCheckbox () {
      const newModel = this.model

      if (!this.isChecked) {
        newModel.push(this.value)
      } else {
        this.removeItemFromModel(newModel)
      }

      this.clearErrors()
      this.$emit('change', newModel)
    },
    handleStringCheckbox () {
      if (!this.isChecked) {
        this.$emit('change', this.value)
      } else {
        this.$emit('change', null)
      }

      this.clearErrors()
    },
    handleBooleanCheckbox () {
      this.$emit('change', !this.model)

      this.clearErrors()
    },
    toggleCheck () {
      if (this.isModelArray) {
        this.handleArrayCheckbox()
      } else if (this.isModelBoolean) {
        this.handleBooleanCheckbox()
      } else {
        this.handleStringCheckbox()
      }
    },
  },
}

</script>

<style lang="scss" scoped>

</style>
